module.exports = __webpack_public_path__ + "media/assets/icons/ic-palette-ce79bb2c62ddb55493b80db66cda6160.svg";